var _path, _mask, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGotTheBoneDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 89,
    viewBox: "0 0 95 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17V25H12V21H16H22V28H17V39H10V49H14V58H9V65H16V72H12V77H22V83H42V87H59V83H75V78H81V69H85V58H81V52H86V44V34H80V28V21H86V25H95V17H92V9H85V4H72V7H67V4H59V0H36V4H31V8H25V4H20H9V10H4V17H0ZM30 27H36V33H30V27ZM68 27H62V33H68V27Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 58,
    width: 85,
    height: 31,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 5,
    y: 58,
    width: 85,
    height: 31
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 60H25V69H70V60H88V70H79V77H88V87H70V78H25V87H7V77H16V70H7V60Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 60H25V69H70V60H88V70H79V77H88V87H70V78H25V87H7V77H16V70H7V60Z",
    fill: "#AAD78C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 60H27V58H25V60ZM7 60V58H5V60H7ZM25 69H23V71H25V69ZM70 69V71H72V69H70ZM70 60V58H68V60H70ZM88 60H90V58H88V60ZM88 70V72H90V70H88ZM79 70V68H77V70H79ZM79 77H77V79H79V77ZM88 77H90V75H88V77ZM88 87V89H90V87H88ZM70 87H68V89H70V87ZM70 78H72V76H70V78ZM25 78V76H23V78H25ZM25 87V89H27V87H25ZM7 87H5V89H7V87ZM7 77V75H5V77H7ZM16 77V79H18V77H16ZM16 70H18V68H16V70ZM7 70H5V72H7V70ZM25 58H7V62H25V58ZM27 69V60H23V69H27ZM70 67H25V71H70V67ZM68 60V69H72V60H68ZM88 58H70V62H88V58ZM90 70V60H86V70H90ZM79 72H88V68H79V72ZM81 77V70H77V77H81ZM88 75H79V79H88V75ZM90 87V77H86V87H90ZM70 89H88V85H70V89ZM68 78V87H72V78H68ZM25 80H70V76H25V80ZM23 78V87H27V78H23ZM25 85H7V89H25V85ZM9 87V77H5V87H9ZM7 79H16V75H7V79ZM14 70V77H18V70H14ZM7 72H16V68H7V72ZM5 60V70H9V60H5Z",
    fill: "#35620E",
    mask: "url(#path-2-outside-1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 9V5H51V9H54V13V42H58V45V50H63V53H66V60H69V70H62V74H56V78H42V74H34V70H30V55H34V50H38V45H42V39V9H46Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52H41V57H37V64H41H45V69H53V64H57V57H53V52Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotTheBoneDog);
export default __webpack_public_path__ + "static/media/got-the-bone-dog.707768b37135a693b8f133f99d8a0cf5.svg";
export { ForwardRef as ReactComponent };